export const GERMAN_CUSTOM_MEMBERS = '400+';
